var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GmapMap',{ref:"mapRef",staticStyle:{"width":"100%","height":"500px"},attrs:{"options":{
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true,
      disableDefaultUi: false
    },"center":_vm.center,"zoom":10}}),_c('div',{ref:"legend",staticClass:"legend"},_vm._l((10),function(i){return _c('div',{key:i,staticClass:"legend__row"},[_c('div',{staticClass:"legend__color",style:({ background: `rgba(88, 102, 219, ${i * 0.1})` })}),_c('div',[_vm._v("\n        "+_vm._s(Number(i * 10 - 9.9).toFixed(1))+"-"+_vm._s(Number(i * 10).toFixed(1))+"\n        %\n      ")])])}),0),_c('div',{ref:"variable",staticClass:"variable"},[_c('div',[_vm._v("ZIP: "+_vm._s(_vm.featureId))]),_c('div',[_vm._v("Value: "+_vm._s(_vm.featureValue)+"%")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }